var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTutorialLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 241,
    viewBox: "0 0 340 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.638 173.578C308.749 160.567 327.757 160.397 323.458 176.69",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.139 156.89C289.23 146.141 305.353 145.576 305.353 161.133",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2338 176.407C16.84 161.699 40.3167 154.061 40.3167 175.559",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258.684 83.9128H320.346",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.274 59.87C117.99 59.87 155.44 59.87 173.826 59.87",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2405 186.307C92.6462 170.467 156.855 143.03 193.343 132.281M61.249 141.898C80.7662 147.838 167.886 221.947 274.523 132.564",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.909 131.999L189.101 192.813M221.912 163.961C220.309 172.541 217.047 191.455 217.952 192.813",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.471 124.361L160.248 191.964",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.469 113.613L132.529 192.813",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M109.334 100.036L102.263 192.813",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8135 97.7726C99.3056 117.774 132.811 142.181 267.168 167.356M81.0478 93.8126L74.2592 182.63",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.249 143.03L139.6 113.896",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6338 112.764C92.2681 136.147 122.741 186.533 139.034 194.227",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9134 92.6814C35.6208 113.726 60.9648 168.204 75.3905 192.247H80.482C37.7705 91.8329 55.8734 75.1142 133.942 112.764C197.755 143.539 266.319 141.32 253.873 137.939C241.428 134.557 172.976 126.059 137.053 104.561C101.131 83.0644 67.1877 75.71 51.9134 92.6814Z",
    fill: "#2F3036",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.168 128.604C284.14 133.356 265.754 173.013 254.44 192.247H260.097C272.731 173.484 293.587 133.696 275.937 124.644C253.874 113.33 218.234 139.636 218.234 139.636C218.234 139.636 160.814 171.976 133.377 188.004C134.226 189.607 136.036 192.813 136.488 192.813C134.791 188.57 205.222 152.364 205.222 152.364C205.222 152.364 245.954 122.664 267.168 128.604Z",
    fill: "#2F3036",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.70312,
    y: 192.181,
    width: 328.246,
    height: 2.96,
    rx: 1.48,
    fill: "#2F3036",
    stroke: "#2F3036"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8066 204.912H89.3643",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.549 204.912H162.111",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M191.324 204.052H209.081",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.411 204.339H243.163",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254.905 204.625H299.012",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57 215.795H68.7426",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.918 215.795L154.951 215.795",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.989 215.222H197.338",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M218.532 215.222C220.328 215.506 222.124 215.789 231.839 215.935C241.553 216.082 259.133 216.082 266.96 216.082C274.788 216.082 272.33 216.082 271.348 216.082C270.366 216.082 270.933 216.082 271.231 216.082",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M231.135 226.965H261.78",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M166.407 226.965H210.8",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0684 226.965H149.796",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 238.994H126.883",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.926 238.135H171.848",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M185.597 239.28H225.12",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216.819 135.676C230.302 150.196 258.116 179.801 261.511 182.064",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M253.026 147.838C250.198 162.076 244.767 191.002 245.672 192.813",
    stroke: "#2F3036",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.082 66.9414H92.0792",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M156.289 75.1442H285.272",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67773 54.2127H33.2463C34.3777 50.4413 38.564 43.1813 46.2577 44.3127C41.4492 18.8556 83.312 1.60127 93.4949 38.3727C99.6235 33.847 114.653 29.2082 125.741 46.8585H150.915",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9678 10.3699C94.3421 0.187 119.799 -6.88443 124.042 17.7242C129.699 13.387 142.654 8.44643 149.216 23.3813",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M239.448 65.8099C237.374 55.3441 239.618 35.7704 265.188 41.2013C265.188 18.5727 303.939 16.027 295.171 47.1413C301.017 47.9899 312.199 53.251 310.162 67.507H338.165",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0829 192.53C24.4772 180.933 3.82857 166.224 1 187.721",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8516 171.599C30.4173 177.444 32.171 189.815 34.6601 192.53",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6992 161.698C27.8706 145.01 51.6307 140.484 49.0849 165.941",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M286.969 170.75C289.137 164.621 294.38 154.684 298 163.961C301.621 173.239 297.623 186.307 295.172 191.681",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M314.689 171.316C312.992 176.69 309.994 188.4 311.578 192.247",
    stroke: "#2F3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTutorialLogo);
export default __webpack_public_path__ + "static/media/ic_tutorial_logo.1c7fff97fbfde8c885679313bac0022a.svg";
export { ForwardRef as ReactComponent };